import styled from "@emotion/styled";
import type { CurrentViewport } from "@stepfinance/react";
import { Breakpoints, useViewportWidth } from "@stepfinance/react";
import { Layout } from "antd";
import type { BasicProps } from "antd/lib/layout/layout";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { AppBar } from "../../components/AppBar";
import { HEADER_HEIGHT } from "../../constants";
import { DegradedPerformanceBanner } from "./DegradedPerformanceBannner";
import { SideNavComponent } from "./SideNavComponent";

const { Header, Content } = Layout;
export const SIDENAV_WIDTH = 260;

export const AppLayout = (props) => {
  const { pathname } = useLocation();
  const { currentViewport } = useViewportWidth();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Layout>
      <SideNavComponent />
      <Layout>
        <LayoutHeader currentViewport={currentViewport}>
          <DegradedPerformanceBanner />
          <AppBar />
        </LayoutHeader>
        <LayoutContent currentViewport={currentViewport}>
          <ContentContainer>{props.children}</ContentContainer>
        </LayoutContent>
      </Layout>
    </Layout>
  );
};

const LayoutHeader = styled(Header)<BasicProps & { currentViewport?: CurrentViewport }>`
  position: fixed;
  left: ${({ currentViewport }) => (currentViewport === "Desktop" ? `${SIDENAV_WIDTH}px` : "0px")};
  height: ${HEADER_HEIGHT};
  line-height: 32px !important;
  display: flex;
  flex-direction: column;
  width: calc(100vw - ${({ currentViewport }) => (currentViewport === "Desktop" ? `${SIDENAV_WIDTH}px` : "0px")});
  padding: 0;
  z-index: 3;
  background: black;
`;

const LayoutContent = styled(Content)<BasicProps & { currentViewport?: CurrentViewport }>`
  position: relative;
  left: ${({ currentViewport }) => (currentViewport === "Desktop" ? `${SIDENAV_WIDTH}px` : 0)};
  min-height: calc(100vh - ${HEADER_HEIGHT});
  margin: calc(${HEADER_HEIGHT} + calc(100px - ${HEADER_HEIGHT})) 0; // Add 32px for the "Degraded Performance" Banner

  display: flex;
  justify-content: center;
  width: calc(100vw - ${({ currentViewport }) => (currentViewport === "Desktop" ? `${SIDENAV_WIDTH}px` : "0px")});
  padding: ${({ currentViewport }) => (currentViewport === "Desktop" ? "0 32px 0 16px" : "0 16px")};
`;

/**
 * Contains page content and enforces max-width for each breakpoint
 */
const ContentContainer = styled.div`
  width: 100%;

  @media (min-width: ${Breakpoints.XXL}px) {
    max-width: 75vw;
  }
  @media (min-width: ${Breakpoints.XL}px) and (max-width: ${Breakpoints.XXL - 1}px) {
    max-width: 960px;
  }
  @media (min-width: ${Breakpoints.L}px) and (max-width: ${Breakpoints.XL - 1}px) {
    max-width: 892px;
  }
`;
